import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  value: [],
  loading: false,
  error: null,
};

const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));

export const feedSlice = createSlice({
  name: "feed",
  initialState,
  reducers: {
    updateFeedTopics: (state, action) => {
      state.value = action.payload;
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
  },
});
// Action creators are generated for each case reducer function
export const { updateFeedTopics, setLoading, setError } = feedSlice.actions;

export default feedSlice.reducer;
